import { render } from "./TermsAndConditionsPage.vue?vue&type=template&id=35f25a40&scoped=true"
import script from "./TermsAndConditionsPage.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsPage.vue?vue&type=script&lang=js"

import "./TermsAndConditionsPage.vue?vue&type=style&index=0&id=35f25a40&scoped=true&lang=css"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f25a40"]])

export default __exports__